import { MatFormFieldDefaultOptions } from "@angular/material";

export const appearanceConfig: MatFormFieldDefaultOptions = {
    appearance: 'outline'
  };